import type { HttpErrorResponse } from '@angular/common/http';
import { ApiError } from '../../http/errors/api-error';

export function parseHttpErrorResponse(error: HttpErrorResponse) {
    let body = error.error;

    if (typeof body === 'string') {
        if (error.headers.get('Content-Type') === 'application/json') {
            try {
                body = JSON.parse(body);
            } catch (e) {
                // Unable to parse JSON
            }
        }
    }

    if (error.status == 413) {
        return new ApiError({
            message: 'The request content is too large',
            type: 'request_too_large',
            code: 413,
        });
    }

    if (body.error) {
        return new ApiError(body.error);
    }

    return body || error;
}

export function toApiError(error: HttpErrorResponse): ApiError | null {
    let body = error?.error;

    if (typeof body === 'string') {
        if (error.headers.get('Content-Type') === 'application/json') {
            try {
                body = JSON.parse(body);
            } catch (e) {
                // Unable to parse JSON
            }
        }
    }

    if (body?.error) {
        return new ApiError(body.error);
    }

    if (body?.message) {
        return new ApiError({
            message: body.message,
            type: 'unknown',
            code: error.status,
        });
    }

    return null;
}
